// Exports the "textcolor" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/textcolor')
//   ES2015:
//     import 'tinymce/plugins/textcolor'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_tinymce@4.9.4@tinymce/plugins/textcolor/index.js
// module id = XZHs
// module chunks = 0